import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';
import { CredentialingListItemData } from './constants';

export const buildCredentialingListRow = (item: CredentialingListItemData) => ({
  id: item.id,
  active: item.status === 'Active',
  nameForTable: {
    image: '',
    firstName: item.name,
    lastName: '',
    permission: item.subtitle,
  },
  secondaryStatus: item.secondaryStatus,
});

export const toDate = (value?: unknown): Date | undefined =>
  value ? new Date(value as string | Date) : undefined;

// how close an expiration has to be before a record is flagged
export const EXPIRING_SOON_DAYS = 30;

/** "Expired" / "Expiring Soon", or nothing while the record is still valid */
export const getValidity = (expirationDate?: string | null) => {
  if (!expirationDate) return undefined;

  // parseISO keeps a bare date in local time; new Date() would read it as UTC
  const parsed = parseISO(expirationDate);
  const date = isValid(parsed) ? parsed : new Date(expirationDate);
  if (!isValid(date)) return undefined;

  const daysLeft = differenceInCalendarDays(date, new Date());
  if (daysLeft < 0) return 'Expired';
  if (daysLeft <= EXPIRING_SOON_DAYS) return 'Expiring Soon';
  return undefined;
};
